import { ChangeDetectorRef, Component, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { ControlUser } from '../model/controlUser';
import { DevicePilomat } from '../model/devicePilomat';
import { UserService } from '../service/user.service';
import { Log } from '../util/log';

@Component({
  selector: 'app-link-device-owner-dialog',
  templateUrl: './link-device-owner-dialog.component.html',
  styleUrls: ['./link-device-owner-dialog.component.css']
})
export class LinkDeviceOwnerDialogComponent implements OnInit {

  @ViewChild('linkdeviceownerloader', { static: true }) loader;
  @ViewChild('linkdeviceownertable', { static: true }) table;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  @Output() selected = new EventEmitter<ControlUser>();
  selectedOwner: ControlUser;
  selectedRow: number;

  dataSource: OwnerSource;

  displayedColumns: string[] = ['displayName', 'email' ];

  device: DevicePilomat;

  owner: ControlUser;
  ownerList: ControlUser[];

  constructor(public dialogRef: MatDialogRef<LinkDeviceOwnerDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, private userService: UserService, private cdRef:ChangeDetectorRef) { 

      this.device = data.device;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit() {

    this.getOwnerList();
  }

  getOwnerList() {

    Log.debug("getOwnerList");

    this.loader.showLoading();

    this.dataSource = new OwnerSource(this.userService);

      this.table.dataSource = this.dataSource;

      this.dataSource.ownersData.subscribe(data => {

        Log.debug("ownersData: " + data);

        setTimeout(() => {

          this.cdRef.detectChanges();
        });
        
      }, error => {

        this.loader.hideLoading();
        this.loader.showError();
      });

      setTimeout(() => {
        
        this.sort.sortChange.subscribe(v => Log.debug(v) )

        this.dataSource.isLoading.subscribe(isLoading => {

          if(!isLoading) {
            this.loader.hideLoading();
          }
        });
      });
  }

  onRowClicked(row) {

    Log.debug('clicked owner ' + JSON.stringify(row));

    this.selectedRow = row.id;

    this.selected.emit(row);
    this.selectedOwner = row;
    
    this.cdRef.detectChanges();

    this.dialogRef.close({ owner: row });
  }

  closeDialog() {
 
    this.dialogRef.close();
  }
}

export class OwnerSource extends MatTableDataSource<ControlUser> {

  isLoading = new BehaviorSubject(false);
  ownersData = new BehaviorSubject<ControlUser[]>([]);

  constructor(private userService: UserService) {
    super();

    // this.filterPredicate = function (data: DevicePilomat, filter: string): boolean {
    //   Log.debug("filter: " + filter);
    //   return false;
    // }
  }

  loadData() {

    this.isLoading.next(true);

    const obs = this.userService.getOwners();
    obs.subscribe(data => {

      this.isLoading.next(false);
      this.ownersData.next(data);
    });
  }

  connect(): BehaviorSubject<ControlUser[]> {

    this.loadData();
    return this.ownersData;
  }

  disconnect() {
  }
}
